import { render, staticRenderFns } from "./SidebarMeasurementsList.vue?vue&type=template&id=6e90220e&scoped=true&"
import script from "./SidebarMeasurementsList.vue?vue&type=script&lang=js&"
export * from "./SidebarMeasurementsList.vue?vue&type=script&lang=js&"
import style0 from "./SidebarMeasurementsList.vue?vue&type=style&index=0&id=6e90220e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e90220e",
  null
  
)

export default component.exports